import { MenuItem } from '@fluentui/react-components';
import { DismissRegular } from '@fluentui/react-icons';
import type { Column, RowData } from '@tanstack/react-table';
import { useCallback } from 'react';

export function resetFilter<TData extends RowData>(column: Column<TData, unknown>) {
    column.setFilterValue('');
}

type ResetFilterMenuItemProps<TData, TValue> = {
    column: Column<TData, TValue>;
    closePopover: () => void;
    resetOperation?: (resetDropdown: boolean) => void;
};

export function ResetFilterMenuItem<TData, TValue>({
    column,
    closePopover,
    resetOperation,
}: ResetFilterMenuItemProps<TData, TValue>) {
    const onClick = useCallback(() => {
        closePopover();
        resetFilter(column);
        resetOperation?.(true);
    }, [column, resetOperation, closePopover]);

    return (
        <MenuItem icon={<DismissRegular />} onClick={onClick}>
            Filter zurücksetzen
        </MenuItem>
    );
}
